import LegalPageLayout from '../components/layout/LegalPageLayout';

const SECTIONS = [
  {
    heading: '1. Information We Collect',
    body: 'We collect information you provide directly, such as your name, email, phone number, date of birth, address, bank details, and identity verification documents (BVN, NIN) when you register or apply for a service. We also collect information automatically, including device data, IP address, and usage activity within the app.',
  },
  {
    heading: '2. How We Use Your Information',
    body: 'We use your information to create and manage your account, process loan applications and repayments, verify your identity (KYC/AML compliance), assess creditworthiness, detect and prevent fraud, communicate with you about your account, and improve our products and services.',
  },
  {
    heading: '3. How We Share Your Information',
    body: 'We do not sell your personal data. We may share information with credit reference bureaus, payment processors, regulatory bodies, and service providers who help us operate the platform, each bound by confidentiality obligations. We may also disclose information where required by law.',
  },
  {
    heading: '4. Data Security',
    body: 'We use industry-standard safeguards, including encryption in transit and at rest, access controls, and regular security reviews, to protect your information from unauthorized access, alteration, or disclosure.',
  },
  {
    heading: '5. Your Rights',
    body: 'You may request access to, correction of, or deletion of your personal information, subject to our legal and regulatory obligations (for example, records we must retain for compliance purposes). You can manage most of your details directly from your profile settings, or contact us for assistance.',
  },
  {
    heading: '6. Cookies',
    body: 'We use cookies and similar technologies to keep you signed in, remember your preferences, and understand how the app is used. See our Cookie Policy for more detail.',
  },
  {
    heading: '7. Changes to This Policy',
    body: 'We may update this policy from time to time. We will notify you of material changes through the app or by email before they take effect.',
  },
  {
    heading: '8. Contact Us',
    body: 'If you have questions about this Privacy Policy or how your data is handled, contact us at support@mypcredit.com or through our Contact Us page.',
  },
];

export default function PrivacyPolicy() {
  return (
    <LegalPageLayout
      eyebrow="Legal"
      title="Privacy Policy"
      updated="September 2026"
      sections={SECTIONS}
    />
  );
}
